import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Users
import Users from "../pages/Users/users-list";
import UserDetail from "../pages/Users/user-detail";

// Job Posts
import JobPosts from "../pages/JobPosts/job-posts-list";

// Companies
import Companies from "../pages/Companies/companies-list";

// Community Posts
import CommunityPosts from "../pages/CommunityPosts/community-posts-list";

// Comments
import Comments from "../pages/Comments/comments-list";

// Salary Entries
import SalaryEntries from "../pages/SalaryEntries/salary-entries-list";

// Reports
import Reports from "../pages/Reports/reports-list";

// Site Settings
import SiteSettings from "../pages/SiteSettings/site-settings-list";

// Pages
import Pages from "../pages/Pages/pages-list";

// Contact Messages
import ContactMessages from "../pages/ContactMessages/contact-messages-list";

// Premium Plans
import PremiumPlans from "../pages/PremiumPlans/premium-plans-list";

// Payments
import Payments from "../pages/Payments/payments-list";

// Admin Users
import AdminUsers from "../pages/AdminUsers/admin-users-list";

// Professions
import Professions from "../pages/Professions/professions-list";

// Cities
import Cities from "../pages/Cities/cities-list";

import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/users/:id", component: <UserDetail /> },
  { path: "/users", component: <Users /> },
  { path: "/job-posts", component: <JobPosts /> },
  { path: "/companies", component: <Companies /> },
  { path: "/community-posts", component: <CommunityPosts /> },
  { path: "/comments", component: <Comments /> },
  { path: "/salary-entries", component: <SalaryEntries /> },
  { path: "/reports", component: <Reports /> },
  { path: "/site-settings", component: <SiteSettings /> },
  { path: "/pages", component: <Pages /> },
  { path: "/contact-messages", component: <ContactMessages /> },
  { path: "/premium-plans", component: <PremiumPlans /> },
  { path: "/payments", component: <Payments /> },
  { path: "/admin-users", component: <AdminUsers /> },
  { path: "/professions", component: <Professions /> },
  { path: "/cities", component: <Cities /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
];

export { authProtectedRoutes, publicRoutes };
